// extracted by mini-css-extract-plugin
export var gif = "_la-0";